import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: "How do I choose the best plan for me?",
    answer: "We recommend you select the product that represents roughly a 1% reinvestment of your yearly income."
  },
  {
    question: "How do I know the feedback is anonymous and secure?",
    answer: "All responses are collected confidentially, and reported in an anonymized and aggregated way to ensure honest input without fear of judgment."
  },
  {
    question: "What's the difference between the growth objective questionnaires?",
    answer: "All questionnaires are built over the base 360°, and have tailored questions added on top to dig deeper on your needs."
  },
  {
    question: "How long does the process take?",
    answer: "Most evaluations and reports are completed within 2 few weeks, but it may be as soon as all evaluators complete their evaluations. Processing the evaluations and providing the report takes us between 1 and 2 business days."
  },
  {
    question: "Can I invite multiple evaluators?",
    answer: "Yes, you can invite 5-10 evaluators depending on your chosen plan."
  }
];

export default function FAQs() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="mt-[40px] max-w-2xl mx-auto">
      <h3 className="text-2xl font-bold text-gray-900 text-center mb-12">
        FAQs
      </h3>
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="max-w-xl mx-auto"
          >
            <button
              onClick={() => toggleFAQ(index)}
              className="w-full text-left bg-white rounded-lg px-6 py-4 shadow-sm hover:shadow-md transition-all duration-200 border border-gray-100"
            >
              <div className="flex justify-between items-center">
                <h4 className="text-base font-medium text-gray-900 pr-8">
                  {faq.question}
                </h4>
                <ChevronDown 
                  className={`w-5 h-5 text-gray-500 transition-transform duration-200 flex-shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </div>
              <AnimatePresence>
                {openIndex === index && (
                  <motion.div
                    initial={{ height: 0, opacity: 0, marginTop: 0 }}
                    animate={{ height: 'auto', opacity: 1, marginTop: 12 }}
                    exit={{ height: 0, opacity: 0, marginTop: 0 }}
                    transition={{ duration: 0.2 }}
                    className="overflow-hidden"
                  >
                    <p className="text-gray-600 text-sm">
                      {faq.answer}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </button>
          </motion.div>
        ))}
      </div>
    </div>
  );
}